import store from '../store'
import axios from 'axios'
import router from '@/router/index.js'

const AxiosInstance = axios.create();
AxiosInstance.defaults.baseURL = process.env.VUE_APP_BASE_URL;

// Request interceptor
AxiosInstance.interceptors.request.use(request => {
  const token = store.getters['auth/token'];

  // console.log("interceptors token", token);

  if (token) {
    request.headers.common['token'] = `${token}`
  }

  const locale = store.getters['lang/locale'];

  if (locale) {
    request.headers.common['Accept-Language'] = locale
  }

  const resource = store.getters['resource/currentResource'];

  if (resource) {
      request.headers.common['resource'] = resource.key;
  }

  return request
});

AxiosInstance.interceptors.response.use(null, async error => {
  let res = error.response;
  if (res.status === 401 || res.status === 403) {
    // router.push({name: 'Login'})
  }

  if (res.status === 504 || res.status === 500) {
    // this.$noty.error("Oops, something went wrong. Please, try again latter.");
  }
  return Promise.reject(error);
});

export default AxiosInstance;
